export const fallbackMessage = "This action wasn't completed due to a technical issue.";
//# sourceMappingURL=fallbackMessage.js.map